/**
 * ThuysVers Subscription Start Modal
 * Hidden by default. Only shown when "subscription-survey-completed" is dispatched:
 * - After submitting the subscription survey form, or
 * - After clicking "Ga door naar mijn aanbevelingen" on the "already taken" step.
 * Stepper is driven by subscription_survey_result: meals × people, soup if > 0, dessert if > 0, shipping always.
 * Retake link: clears cart before navigating to survey URL.
 */
(function () {
  const STORAGE_KEY = "subscription_survey_result";
  const STEPPER_HIDDEN_CLASS = "tv-survey-intro-popup__stepper-step--hidden";
  const CART_CLEAR_URL =
    typeof Theme !== "undefined" && Theme?.routes?.cart_url
      ? `${Theme.routes.cart_url.replace(/\/?$/, "")}/clear.js`
      : "/cart/clear.js";

  function getPayload() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const data = JSON.parse(raw);
      return data && typeof data === "object" ? data : null;
    } catch {
      return null;
    }
  }

  /**
   * @param {Element} root
   */
  function updateStepper(root) {
    const payload = getPayload();
    const profilesLength = Array.isArray(payload?.profiles) ? payload.profiles.length : 0;
    const profileCountFromPayload = Number(payload?.profileCount);
    const profileCount =
      profileCountFromPayload >= 1 && profileCountFromPayload <= 6
        ? profileCountFromPayload
        : profilesLength;
    let soupCount = 0;
    let dessertCount = 0;
    const addons = Array.isArray(payload?.addOns) ? payload.addOns : Array.isArray(payload?.add_ons) ? payload.add_ons : [];
    addons.forEach((/** @type {{ addonType?: string; addon_type?: string; quantity?: number }} */ addon) => {
      const t = String(addon?.addonType || addon?.addon_type || "").toLowerCase();
      const q = Number(addon?.quantity) || 0;
      if (t === "soup") soupCount += q;
      else if (t === "dessert") dessertCount += q;
    });

    const mealSteps = root.querySelectorAll('[data-tv-stepper="meals"]');
    const n = Math.min(6, Math.max(1, profileCount));
    mealSteps.forEach((li, index) => {
      if (li instanceof HTMLElement) li.hidden = index >= n;
    });

    const soupStep = root.querySelector('[data-tv-stepper="soup"]');
    if (soupStep) soupStep.classList.toggle(STEPPER_HIDDEN_CLASS, soupCount <= 0);

    const dessertStep = root.querySelector('[data-tv-stepper="dessert"]');
    if (dessertStep) dessertStep.classList.toggle(STEPPER_HIDDEN_CLASS, dessertCount <= 0);
  }

  /**
   * Only show when user has just completed the survey or clicked through a guard step.
   * Do NOT show on page load when restoring from session (hasRecommendations/hasSurveyResult).
   */
  /** @param {CustomEvent<{ source?: string }>} event */
  function showModal(event) {
    const source = event?.detail?.source;
    if (source === "mijn-gegevens-metafield" || source === "session-storage") return;
    const root = document.querySelector("[data-tv-subscription-start-modal]");
    if (!root) return;
    updateStepper(root);
    root.classList.remove("tv-survey-intro-popup--hidden");
    root.setAttribute("aria-hidden", "false");
  }

  function closeModal() {
    const root = document.querySelector("[data-tv-subscription-start-modal]");
    if (!root) return;
    root.classList.add("tv-survey-intro-popup--hidden");
    root.setAttribute("aria-hidden", "true");
  }

  /** @param {Event} e */
  async function handleRetakeClick(e) {
    const link = e.target instanceof Element ? e.target.closest("[data-tv-retake-survey]") : null;
    if (!link || !(link instanceof HTMLAnchorElement) || !link.href) return;
    e.preventDefault();
    const url = link.href;
    try {
      await fetch(CART_CLEAR_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      });
    } catch (err) {
      console.warn("[TvSubscriptionStartModal] Error clearing cart before retake:", err);
    }
    window.location.href = url;
  }

  function init() {
    window.addEventListener("subscription-survey-completed", showModal);

    document.addEventListener("click", (e) => {
      const target = e.target instanceof Element ? e.target : null;
      if (target && target.closest("[data-tv-survey-intro-close]")) {
        closeModal();
      }
      if (target && target.closest("[data-tv-retake-survey]")) {
        handleRetakeClick(e);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
